<template>
  <v-flex xs12 :[dinamicFlexSmall]="true" :[dinamicFlexMedium]="true">
    <v-menu
      ref="menu_hora"
      v-model="menu_hora"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="hour"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
      :disabled="disable"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="hour"
          :label=label
          prepend-icon="access_time"
          readonly
          :rules="rules"
          v-on="on"
          :class="clase"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu_hora"
        v-model="hour"
        full-width
        @click:minute="$refs.menu_hora.save(hour)"
        :format="format"
        :min="min_time"
      ></v-time-picker>
    </v-menu>
  </v-flex>
</template>

<script>
export default {
  name: 'hora_picker',
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: null,
      required: true,
    },
    disable: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    size: {
      type: String,
      required: false,
      default: '3',
    },
    clase: {
      type: String,
      required: false,
    },
    format: {
      type: String,
      required: false,
      default: 'ampm',
    },
    min_time: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      hour: this.value,
      menu_hora: false,
    };
  },
  computed: {
    dinamicFlexSmall() {
      return 'sm'.concat(this.size);
    },
    dinamicFlexMedium() {
      return 'md'.concat(this.size);
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    value(val) {
      this.hour = this.value;
    },
    // eslint-disable-next-line no-unused-vars
    hour: {
      deep: true,
      handler() {
        this.$emit('input', this.hour);
      },
    },
  },
};
</script>

<style scoped>

</style>
